import { Button, CircularProgress, Stack } from "@mui/material";
import * as Auth from "../app/auth";
import { LoginStatusText } from "../components";

function Login() {
  const accessToken = Auth.useAccessToken();
  const authResult = Auth.useAuthResult();
  const errorMessage = authResult?.errorMessage;

  const statusText = (): string => {
    if (authResult?.isSuccess && accessToken) {
      return `Hi ${accessToken?.name}`;
    } else if (authResult?.isSuccess === false) {
      return authResult.errorMessage ?? "An unspecified error occurred";
    } else {
      return "Signing you in...";
    }
  };

  const handleLogout = () => {
    Auth.logout();
  };

  return (
    <Stack sx={{ height: "100%", backgroundColor: "#eee", gap: 6 }} alignItems="center" justifyContent="center">
      <CircularProgress size={128} color="success" thickness={1.4} />
      <LoginStatusText text={statusText()} />
      {errorMessage && errorMessage.includes("logout and back in again") && (
        <Button variant="outlined" onClick={handleLogout} sx={{ marginTop: 4 }}>
          Logout
        </Button>
      )}
    </Stack>
  );
}

export default Login;
